export default __webpack_public_path__ + "static/media/request-gray.07ede262.svg";